import {useApp} from "hooks/StateHooks"
import {AppState} from "redux/reducers/AppReducer"
import {store} from 'store'

export interface UpdateApp {
  type: 'UPDATE_APP'
  app: AppState
}

export const updateApp: (app: AppState) => UpdateApp = app => ({
  type: 'UPDATE_APP',
  app,
})

export const updateNotifications = async () => {
  const notifications = await window.axios.get('/notifications')
  const app = useApp()
  if (notifications.data) {
    app.notifications = notifications.data.notifications
    app.unreadNotifications = notifications.data.unreadNotifications
  }

  store.dispatch(updateApp(app))
}
